import { useEffect } from "react";

export const useBodyClass = (className, active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  }, [className, active]);
};
